<template>
  <div>
    <div class="w">
      <div class="title">Smartbones</div>
      <div class="desc_container">
        <p class="article">
          <span>
            Smartbones是世界500强公司品谱集团 (Spectrum
            Brands)旗下的宠物零食品牌。
          </span>
        </p>
      </div>
      <div class="title">品牌简介</div>
    <div class="desc_container">
      <p class="article">
        <span>
            Smartbones是美国上市公司品谱集团(Spectrum Brands)旗下的宠物零食品牌。
            Smartbones宠物零食在欧美发达国家非常受家长的欢迎。
        </span>
        <br /><br />
        <span>
            Smartbones的愿望，Smartbones希望您能拥有健康、快乐的狗狗。
        </span>
        <br /><br />
        <span>
            我们知道，你的狗不仅仅是一只宠物--它们是家人。这就是为什么在了解到兽医和宠物父母对生皮磨牙棒的担忧后，Smartbones开始创造一种不仅健康，而且味道很好的磨牙物替代品--这两个简单的原则指导Smartbones的开发团队,自2008年以来，Smartbones一直都在坚持创新且保证永远不会在质量上妥协。Smartbones品牌的质量控制团队随时随地监控一切--成分、制造过程、工厂设备、
            储存和更多--以确保SmartBones磨牙棒的生产、储存和运输符合美国食品和药物管理局（FDA）的标准，其设施是世界上最现代化的。
        </span>
      </p>
    </div>

      <div class="title">Smartbones质量保证</div>
    <div class="desc_container">
      <p class="article">
        <span>
            因为它们不 "只是宠物" 我们的狗是家庭的一部分--这就是为什么SmartBones的成分、制作方法以及制作人员都是公司的重点。公
            司严格遵守美国食品和药物管理局（FDA）的规定。公司最先进的生产设施已在FDA注册。
        </span>
        <br /><br />
        <span>
            Smartbones如何确保质量? Smartbones 品牌公司拥有经验丰富的人员,公司的质量控制(QC)团队对所有的东西进行监控，包括原料、
            生产过程、工厂设备、储存等等，以确保SmartBones磨牙棒的生产、储存和运输符合FDA标准。
        </span>
      </p>
    </div>

      <div class="title">Smartbones公司拥有最先进的设施</div>
    <div class="desc_container">
      <p class="article">
        <span>
            Smartbones公司的工厂已在FDA注册，并遵循严格的质量控制程序，是最先进
            的生产设施。在生产过程中，每一个与SmartBones磨牙棒接触的表面都要每天消毒数次。
        </span>
      </p>
    </div>

      <div class="title">Smartbones 品牌使用最优质的原料</div>
    <div class="desc_container">
      <p class="article">
        <span>
            所有的原材料都是从主要的供应商那里购买的，并且在用于生产之前由Smartbones
            的质量控制团队进行测试。SmartBones磨牙棒中的鸡肉在生产过程中经过多次消毒以防止细菌污染。
        </span>
      </p>
    </div>

      <div class="title">Smartbones品牌拥有最佳生产实践</div>
    <div class="desc_container">
      <p class="article">
        <span>
            所有工厂工人都穿着制服，戴着手套，戴着发网，
            以防止在生产的各个阶段受到污染。所有产品都在能杀死沙门氏菌的温度下加工。
        </span>
      </p>
    </div>

      <div class="title">Smartbones品牌会进行广泛的测试</div>
    <div class="desc_container">
      <p class="article">
        <span>
            Smartbones品牌的每个工厂都包括一个设备齐全的、最先进的质量保证实验室，以确
            保整个生产过程的质量和安全。SmartBones磨牙棒也由遵循全球标准的外部实验室进行测试。
        </span>
      </p>
    </div>

      <div class="title">SmartBones磨牙棒与生皮磨牙棒有什么不同？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            SmartBones 磨牙棒中绝对没有生皮。它们是由有益于健康的蔬菜和真正的鸡肉制成的。这使得SmartBones磨牙棒非常容易消化，
            而且非常可口。它们还富含维生素和矿物质......对狗来说，它们比任何生皮磨牙棒都要更健康。
        </span>
      </p>
    </div>

      <div class="title">SmartBones磨牙棒是如何制作的？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            SmartBones磨牙棒是用健康的蔬菜制成的，包括红薯、豌豆和胡萝卜，里面有一层令人无法抗拒的真正的鸡肉。
        </span>
      </p>
    </div>

    <div class="title">你们是如何测试SmartBones磨牙棒的消化能力的？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            我们花了两年多的时间进行研究和开发，以获得我们独特的配方，确保它具有高度的消化性和适口性。我
            们按照AAFCO（美国饲料控制官员协会）制定的严格协议进行，并进行了详细的研究，测量消化率。
        </span>
      </p>
    </div>

    <div class="title">您怎么知道狗喜欢SmartBones磨牙棒而不是传统的磨牙棒？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            我们对不同品种和体型的狗进行了口味测试。我们让这些狗在SmartBones磨牙
            棒和几种不同的竞争性狗磨牙棒之间进行选择。90%的狗都认为SmartBones是它们的最爱!    
        </span>
      </p>
    </div>


    <div class="title">为什么SmartBones磨牙棒富含维生素和矿物质？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            我们的SmartBones磨牙棒是在食品级工厂生产的，该工厂有能力用维生素和矿物质来加强配方。我们决定在SmartBones磨牙棒的配方中加入维生素
            和矿物质，以便生产出更均衡、更有营养的磨牙棒......使它们对狗狗更有益处
        </span>
      </p>
    </div>

    <div class="title">为什么咀嚼对狗狗来说很重要？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            咀嚼对狗狗来说是一项必要的、健康的和愉快的活动。狗狗的磨牙棒有助于保持牙齿清洁、颚部强壮，并
            能刺激精神，帮助防止无聊和破坏性行为。SmartBones磨牙棒有助于满足狗的自然咀嚼本能。
        </span>
      </p>
    </div>

    <div class="title">SmartBones磨牙棒有专利吗？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            SmartBones磨牙棒非常独特，因此拥有多项美国和国际专利。
        </span>
      </p>
    </div>

    <div class="title">SmartBones如何保证最高的质量标准？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            没有什么比狗的健康和安全更重要。因此，我们遵循严格的、多层次的安全程序以确保最高的质量标准。在加工之前，我们所有的原材料都要在无菌环境中进行彻底检查和分析。一旦经过检测的原材料进入制造过程，我们将严格遵守FDA（美国食品和药物管理局）
            的卫生规定和制造流程。在我们的狗磨牙棒离开制造厂之前，它们再次被我们的质量控制团队测试。
        </span>
      </p>
    </div>

    <div class="title">我的狗每天可以吃多少块SmartBones磨牙棒？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            这取决于您的狗的大小。 一般来说，每天吃1到2颗SmartBones磨牙
            棒是合适的。请确保您的狗狗得到适合其体型的SmartBones磨牙棒。
        </span>
      </p>
    </div>

    <div class="title">我可以给我的小狗吃SmartBones磨牙棒吗？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            SmartBones磨牙棒对8周大的幼犬来说是安全的。 请记得在咀嚼活动期间监督您的宠物，并确保它能获得大量的清洁水。
        </span>
      </p>
    </div>

    <div class="title">SmartBones磨牙棒的成分和营养成分是什么？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            成分和保证分析可以在所有SmartBones包装上和我们网站上每个产品列表的
             "成分/营养 "部分找到。我们的配方是以蔬菜和鸡肉为基础的，提供狗狗喜欢的口味 
        </span>
      </p>
    </div>

    <div class="title">我如何储存SmartBones磨牙棒？</div>
    <div class="desc_container">
      <p class="article">
        <span>
            开封后，请重新密封在包装袋中，或存放在密闭的容器中。 
        </span>
      </p>
    </div>

    <div class="title">Smartbones 品牌在中国的主要产品</div>
    <div class="desc_container">
      <p class="article">
        <span>
            SmartBones狗狗磨牙棒鸡肉味夹心卷棒零食洁齿骨头小型犬除口臭
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒狗咬胶零食幼犬洁齿骨头小型犬奖励
        </span>
        <br><br>
        <span>
            Smartbones狗狗磨牙棒狗咬胶零食幼犬训练奖励耐咬骨头小型犬泰迪
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒串烧拉布拉多零食狗咬胶宠物幼犬耐咬骨头
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒狗咬胶幼犬骨头大型犬金毛零食洁齿卷咬棒
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒夹心粗皮卷鸡肉干零食幼犬耐咬骨头洁齿咬胶
        </span>
        <br><br>
        <span>
            SmartBones妙脆卷片花生味狗狗磨牙棒咬胶零食宠物洁齿骨头小型犬
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒咬胶零食宠物洁齿骨型犬泰迪安神洁齿卷
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒牛肉味大号咬胶3支耐咬零食骨头大型犬奖励
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒花生味卷棒狗咬胶零食洁齿骨头小型犬
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒中号地瓜味咬胶零食幼犬耐咬胶骨头
        </span>
        <br><br>
        <span>
            SmartBones狗狗磨牙棒中号薄荷味咬胶狗零食洁齿骨头宠物中大型犬
        </span>
      </p>
    </div>

    </div>

    <!-- 底部 -->
<div style="height: 100px;"></div>
  <foot/>
  
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.title {
  margin: 20px auto;
  font-size: 20px;
  color: #333;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
}

.desc_container {
  margin-top: 20px;
  padding: 15px 15px;
  background-color: #f8f8f8;
  .article {
    margin: 0;
    padding: 0;
    span {
      font-size: 16px;
      color: #666;
      line-height: 1.75em;
    }
  }
}
</style>